// 公共filters

import Vue from "vue"
import address from "../../config/address.config"

// 过滤器数组
var filters = {
  // 图片地址拼接
  imgCdn(val) {
    return address.IMAGE_ADDRESS + val
  },
  // 过滤邮件内容
  filterEmailHtml(emailHtml) {
    let styleRE = /<style(([\s\S])*?)<\/style>/g
    let zindexRE = /z-index:/g
    if (!emailHtml) return
    let temp = ""
    // 过滤掉style标签
    temp = emailHtml.replace(styleRE, "")
    // 将z-index:样式置为无效
    temp = temp.replace(zindexRE, "_z-index:")
    //浏览器本地存储的邮件详情可能包含过期的token，替换为本地存储的有效token
    let reg = /\/emails\/attachments\/id\?token=([^\s\t\r\n""'<>]*)&id=/,
      oldTokenT = temp.match(reg)
    if (oldTokenT) {
      let oldToken = oldTokenT[1],
        newToken = localStorage.Token,
        regToken = new RegExp(oldToken, "g") //全文匹配
      temp = temp.replace(regToken, newToken)
    }
    return temp
  },
  //转换文件大小
  transformKB(limit) {
    if (typeof limit === "number") {
      var size = ""
      if (limit < 0.1 * 1024) {
        //如果小于0.1KB转化成B
        size = limit.toFixed(2) + "B"
      } else if (limit < 0.1 * 1024 * 1024) {
        //如果小于0.1MB转化成KB
        size = (limit / 1024).toFixed(2) + "KB"
      } else if (limit < 0.1 * 1024 * 1024 * 1024) {
        //如果小于0.1GB转化成MB
        size = (limit / (1024 * 1024)).toFixed(2) + "MB"
      } else {
        //其他转化成GB
        size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB"
      }
      var sizestr = size + ""
      var len = sizestr.indexOf(".")
      var dec = sizestr.substr(len + 1, 2)
      if (dec == "00") {
        //当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2)
      }
      return sizestr
    } else {
      return limit
    }
  }
}

export default filters



// WEBPACK FOOTER //
// ./src/service/filters.js